import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import fadeElements from "./fadeElements";

gsap.registerPlugin(ScrollTrigger);

export default function page() {

    /// this not from front page
    // if(document.querySelector('body').classList.contains('home')) {
    //     return false;
    // }


    const fade              = fadeElements();
    const logo              = document.querySelector('.js-main-logo');
    const pageIntro         = document.querySelector('.js-intro');
    const pageIntroTemplate = document.querySelector('.js-page-header');
    const pageIntroTitle    = document.querySelector('.js-page-title');
    const pageIntroText     = document.querySelector('.js-intro-text');
    const pageIntroBtn      = document.querySelector('.js-intro-btn');
    const pageIntroBlock    = document.querySelector('.js-intro-block');
    const pageIntroBlock2    = document.querySelector('.js-intro-block2');
    const headerButtons     = document.querySelector('.js-header-buttons');
    const headerButtons2     = document.querySelector('.js-langs-sel');
    const isCityTemplate    = document.querySelector('.page-template-template-city_home');
    const triggerDektop      = document.querySelector('.js-trigger-desktop');



    if (triggerDektop) {
        setTimeout(() => {
            if (window.innerWidth > 768) {
                triggerDektop.click();
            }
        }, 500);
    }

    // Default
    const allDefaults = () => {
    
        fade.fadeDefault({target: logo});

        fade.fadeDefaultTop({target: pageIntroTitle});

        if(pageIntroText) {
            fade.fadeDefaultTop({target: pageIntroText});
        }

        if(pageIntroBtn) {
            fade.fadeDefaultTop({target: pageIntroBtn});
        }

        if(headerButtons) {
            fade.fadeDefaultTop({target: headerButtons});
        }
        if(headerButtons2) {
            fade.fadeDefault({target: headerButtons2});
        }
    }

    const loader = () => {

        fade.fadeIn({
            target: logo,
            delay: 0.4
        }); 
        
        fade.fadeInTop({
            target: headerButtons,
            delay: 0.6
        });

        fade.fadeIn({
            target: headerButtons2,
            delay: 0.6
        });

        fade.fadeInTop({
            target: pageIntroTitle,
            delay: 0.8
        });

        if(pageIntroText) {
            fade.fadeInTop({
                target: pageIntroText,
                delay: 1.2
            });
        }

        if(pageIntroBtn) {
            fade.fadeInTop({
                target: pageIntroBtn,
                delay: 1.6
            });
        }

        if(pageIntroBlock) {
            gsap.to(pageIntroBlock, {
                translateY: 0,
                opacity: 1,
                delay: 0.9,
                duration: 1,
            });
            setInterval(() => {
                pageIntroBlock.classList.add('started');
            }, 900);
        }

        if(pageIntroBlock2) {
            gsap.to(pageIntroBlock2, {
                translateY: 0,
                opacity: 1,
                delay: 0.9,
                duration: 1,
            });
        }

    }

    if(pageIntro){
        ScrollTrigger.create({
            trigger: pageIntro,
            pin: '.intro-wrap',
            start: 'top top',
            end: () => 'bottom',
            onUpdate: (self) => {
                // let progress = (self.progress.toFixed(1) * 5) < 1 ? 1 : (self.progress.toFixed(1) * 5);
                // let fixedProgress = progress > 1.5 ? progress/2 : progress;
                // gsap.to(pageIntro.querySelector('video'), {
                //     scale: fixedProgress
                // });
            }, 
        })
    }

    if(pageIntroTemplate){
        ScrollTrigger.create({
            trigger: pageIntroTemplate,
            pin: '.js-page-header-wrap',
            start: 'top top',
            end: () => 'bottom',
        })
    }

    // Load intro
    if(isCityTemplate){
        allDefaults();
        loader();
    }

}